import { _ } from 'utils'
import { createEventRoute } from 'utils/routes'
import SpeakerList from './SpeakerList'
import CreateSpeaker from './CreateSpeaker'
import UpdateSpeaker from './UpdateSpeaker'

export default {
    speakerList: createEventRoute({
        title: _('portal_menu.speakers', {}, false),
        breadcrumb: _('portal_menu.speakers', {}, false),
        path: '/speakers',
        component: SpeakerList,
        exact: true,
        context: 'speakers'
    }),
    createSpeaker: createEventRoute({
        title: _('portal_menu.speakers_create', {}, false),
        breadcrumb: _('portal_menu.speakers_create', {}, false),
        path: '/speakers/create',
        component: CreateSpeaker,
        exact: true,
        hasBackButton: true,
        context: 'speaker-create'
    }),
    updateSpeaker: createEventRoute<{ id: number }>({
        title: _('portal_menu.speakers_update', {}, false),
        breadcrumb: _('portal_menu.speakers_update', {}, false),
        path: '/speakers/:id',
        component: UpdateSpeaker,
        exact: true,
        hasBackButton: true,
        context: 'speaker-update'
    })
}
